import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, FormGroup, Button, Label } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
import { getSystemList, getSystemCity, createBusinessListing, findRegisterBusiness } from '../../services/api/api-service';
import Select from "react-select";
import { useHistory } from 'react-router-dom';
import UploadFile from '../Components/uploadFile';
import MtSweetAlert from '../Components/MtSweetAlert';
import MtFormLayout from '../Components/MtFormLayout';
import { getLocalData } from '../../services/global-storage';
import _ from 'lodash';

const AddBusinessProfile = (props) => {
    const token = getLocalData('userId');
    const formRef = useRef(null);

    let history = useHistory();
    const [transporterType, setTransporterType] = useState(null);
    const [transporterTypeList, setTransporterTypeList] = useState([]);

    // Alert states
    const [conformMsg, setConformMsg] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorStatus, setErrorStatus] = useState(false);
    const [alertMsg, setAlertMsg] = useState("Something Wrong!");

    // Form data states (now controlled for auto-filling)
    const [uploadData, setUploadData] = useState([]);
    const [listingCategory, setlistingCategory] = useState(null);
    const [listingCategoryList, setListingCategoryList] = useState([]);
    const [stateValue, setStateValue] = useState();
    const [stateList, setStatelist] = useState([]);
    const [cityValue, setCityValue] = useState(null);
    const [cityList, setCitylist] = useState([]);
    const [submitStatus, setSubmitStatus] = useState(false);
    const [businessCardValue, setBusinessCardValue] = useState(null);
    const [mobileStatus, setMobileStatus] = useState(false);
    const [businessId, setBusinessId] = useState(null);
    const [verificationStatus, setVerificationStatus] = useState({ label: "False", value: false });
    const [surveyStatus, setSurveyStatus] = useState({ label: "No", value: false });

    // Controlled state for form fields (for OCR auto-filling)
    const [companyName, setCompanyName] = useState('');
    const [contactPerson, setContactPerson] = useState('');
    const [contactNumber, setContactNumber] = useState('');
    const [ownerPhone, setOwnerPhone] = useState('');
    const [businessEmail, setBusinessEmail] = useState('example@gmail.com');
    const [website, setWebsite] = useState('');
    const [address, setAddress] = useState('');
    const [pin, setPin] = useState('');
    const [routeVehicleLoaded, setRouteVehicleLoaded] = useState('');
    const [specialServices, setSpecialServices] = useState('');

    const goBack = () => {
        history.goBack();
        setSubmitStatus(false);
    };

    const transporterTypeOptions = [
        { label: 'LCV & 20FT Container Transport', value: 'LCV & 20FT Container Transport' },
        { label: '32FT Container Transport', value: '32FT Container Transport' },
        { label: 'HCV Vehicle Transport', value: 'HCV Vehicle Transport' },
        { label: 'Trailor & ODC Transport', value: 'Trailor & ODC Transport' },
        { label: 'Car Carrier Transport', value: 'Car Carrier Transport' },
        { label: 'Parcel Booking Transport', value: 'Parcel Booking Transport' },
    ];

    const handleVisitingCardUpload = async (input) => {
        console.log('📤 handleVisitingCardUpload called with:', input);

        // Check if input is a File object (indicates upload might not have completed or is in progress)
        if (input instanceof File) {
            console.warn('⚠️ Received a File object. Upload may still be in progress. Ignoring this call.');
            return;  // Skip processing; wait for the S3 URL call
        }

        // Assume input is the S3 URL (string)
        const s3Url = input;
        if (!s3Url || typeof s3Url !== 'string') {
            console.error('❌ Invalid S3 URL received:', s3Url);
            alert('Invalid image URL. Upload may have failed.');
            return;
        }

        // Basic validation: Check if it looks like a valid S3 URL
        const expectedBucket = 'moverstrip-prod';  // Replace with your actual bucket name if different
        const isValidS3Url = s3Url.startsWith('https://') && s3Url.includes(expectedBucket) && s3Url.includes('business-cards/');
        if (!isValidS3Url) {
            console.error('❌ URL does not match expected S3 format:', s3Url);
            alert('Image URL is not valid. Please check the upload.');
            return;
        }

        console.log('✅ S3 URL validated. Proceeding with OCR (skipping HEAD check to avoid CORS).');

        console.log('📦 FINAL PAYLOAD TO BACKEND:', {
  imageUrl: s3Url,
  type: typeof s3Url,
});

console.log('📡 FETCH HEADERS:', {
  'Content-Type': 'application/json',
});


        // Proceed directly with OCR API call (backend will verify the image by downloading it)
        try {
  const res = await fetch('https://api.moverstrip.com/api/visiting-cards/extract', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    mode: 'cors',  // Explicitly enable CORS
    body: JSON.stringify({ imageUrl: s3Url })
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`API error: ${res.status} ${res.statusText} - ${errorText}`);
  }

  const result = await res.json();
  console.log('✅ OCR RESULT:', result);

  // Populate the form using controlled state (instead of setValues)
  if (result?.extractedData) {
    console.log('📝 Setting form values via state...');
    setCompanyName(result.extractedData.companyName || '');
    setContactPerson(result.extractedData.contactPerson || '');
    setContactNumber(result.extractedData.contactNumber || '');
    setOwnerPhone(result.extractedData.contactNumber || '');  // Assuming ownerPhone defaults to contactNumber
    setBusinessEmail(result.extractedData.businessEmail || 'example@gmail.com');
    setWebsite(result.extractedData.website || '');
    setAddress(result.extractedData.address || '');
    setPin(result.extractedData.pin || '');
    console.log('✅ Form values set successfully via state.');
  }

  setBusinessCardValue(s3Url);
  alert('Visiting card processed successfully! The form has been auto-filled.');
} catch (e) {
  console.error('❌ OCR API error:', e);
  alert('Failed to process visiting card. Check console for details.');
}
    };

    const handleValidSubmit = (event, values, actions) => {
        // Merge controlled state with form values for submission
        const mergedValues = {
            ...values,
            companyName,
            contactPerson,
            contactNumber,
            ownerPhone,
            businessEmail,
            website,
            address,
            pin,
            routeVehicleLoaded,
            specialServices,
        };

        if (stateValue == null) {
            setSubmitStatus(true);
            setAlertMsg("State Not Selected!");
        } else if (cityValue == null) {
            setSubmitStatus(true);
            setAlertMsg("City Not Selected!");
        } else {
            const valueSet = {
                state: stateValue.value,
                city: cityValue.value
            };
            const mtBusinessType = [];
            if (listingCategory == null) {
                setSubmitStatus(true);
                setAlertMsg("Business Type Not Selected!");
            } else {
                if (listingCategory.value === "Packers And Movers,Transporter") {
                    mtBusinessType[0] = "Packers And Movers";
                    mtBusinessType[1] = "Transporter";
                } else {
                    mtBusinessType[0] = `${listingCategory.value}`;
                }
                findRegisterBusiness(mergedValues.contactNumber, cityValue.value).then(data => {
                    if (!_.isEmpty(data)) {
                        setBusinessId(data[0].id);
                        setMobileStatus(true);
                    }
                });
            }
            const dataValue = [];
            dataValue.push({
                ...valueSet,
                mtUserId: token,
                companyName: mergedValues.companyName,
                contactPerson: mergedValues.contactPerson,
                address: mergedValues.address,
                businessEmail: mergedValues.businessEmail,
                website: mergedValues.website,
                businessTypeTag: mtBusinessType,
                pin: mergedValues.pin,
                ownerName: mergedValues.contactPerson,
                ownerPhone: mergedValues.ownerPhone,
                contactNumber: mergedValues.contactNumber,
                businessCard: businessCardValue,  // This is now the S3 URL
                routeVehicleLoaded: mergedValues.routeVehicleLoaded,
                specialServices: mergedValues.specialServices,
                vehicleCategory: transporterType?.value || "",
                Verification: verificationStatus.value,
                survey: surveyStatus.value,
            });
            console.log(dataValue);
            setUploadData(dataValue);
            if (!_.isEmpty(dataValue)) {
                setConformMsg(true);
            } else {
                setSubmitStatus(true);
                setAlertMsg("Something Wrong!");
            }
        }
    };

    const submitHandler = () => {
        if (mobileStatus) {
            setErrorStatus(true);
            setConformMsg(false);
            setSuccessMsg(false);
        } else {
            createBusinessListing(uploadData).then(result => {
                setConformMsg(false);
                setSuccessMsg(true);
            }).catch(alert);
        }
    };

    useEffect(() => {
        getSystemList('listtype').then(setListingCategoryList);
        getSystemList('state').then(data => {
            if (!_.isEmpty(data)) {
                setStatelist(data);
            }
        }).catch(e => {
            console.log("Error in State list:", e);
        });
    }, []);

    useEffect(() => {
        if (stateValue) {
            getSystemCity(stateValue.value).then(data => {
                const allCityData = [];
                if (!_.isEmpty(data)) {
                    data.forEach(element => {
                        allCityData.push({ label: element.dbCity, value: element.dbCity });
                    });
                    setCitylist(allCityData);
                }
            }).catch(e => {
                console.log("Error in City list:", e);
            });
        }
    }, [stateValue]);

    return (
        <React.Fragment>
            <MtFormLayout
                breadcrumbsTitle="Business List"
                breadcrumbItem="Add Business Profile"
                title="Add Business Profile"
                subTitle="Fill details or upload visiting card">
                <AvForm ref={formRef} className="needs-validation" onValidSubmit={handleValidSubmit}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom01">Business Category</Label>
                                <Select
                                    value={listingCategory}
                                    onChange={setlistingCategory}
                                    options={listingCategoryList}
                                    classNamePrefix="select2-selection"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <UploadFile
                                    labelValue="Upload Visiting Card"
                                    bucketName="moverstrip-prod"
                                    UploadPath="business-cards/"
                                    fileValue={handleVisitingCardUpload}  // Now receives S3 URL
                                    currentImage={null}
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Company Name</Label>
                                <AvField
                                    name="companyName"
                                    placeholder="Company Name"
                                    type="text"
                                    errorMessage="Enter Company Name"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    value={companyName}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                    id="validationCustom02"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Contact Person</Label>
                                <AvField
                                    name="contactPerson"
                                    placeholder="Contact Person"
                                    type="text"
                                    errorMessage="Enter Contact Person"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    value={contactPerson}
                                    onChange={(e) => setContactPerson(e.target.value)}
                                    id="validationCustom02"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Contact Number</Label>
                                <AvField
                                    name="contactNumber"
                                    placeholder="Contact Number"
                                    type="text"
                                    errorMessage="Enter Contact Number"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    value={contactNumber}
                                    onChange={(e) => setContactNumber(e.target.value)}
                                    id="validationCustom02"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="ownerPhone">Owner Phone</Label>
                                <AvField
                                    name="ownerPhone"
                                    placeholder="Owner Phone"
                                    type="text"
                                    errorMessage="Enter Owner Phone"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    value={ownerPhone}
                                    onChange={(e) => setOwnerPhone(e.target.value)}
                                    id="ownerPhone"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Mail Id (Optional)</Label>
                                <AvField
                                    name="businessEmail"
                                    placeholder="Business Email"
                                    type="text"
                                    errorMessage="Enter Business Email"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    value={businessEmail}
                                    onChange={(e) => setBusinessEmail(e.target.value)}
                                    id="validationCustom02"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Website Url (Optional)</Label>
                                <AvField
                                    name="website"
                                    placeholder="website"
                                    type="text"
                                    className="form-control"
                                    value={website}
                                    onChange={(e) => setWebsite(e.target.value)}
                                    id="validationCustom02"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="12">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Address</Label>
                                <AvField
                                    name="address"
                                    placeholder="Address"
                                    type="text"
                                    errorMessage="Enter Address"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    id="validationCustom02"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="4">
                            <FormGroup>
                                <Label htmlFor="validationCustom01">State</Label>
                                <Select
                                    defaultValue={stateValue}
                                    name="state"
                                    value={stateValue}
                                    onChange={setStateValue}
                                    options={stateList}
                                />
                            </FormGroup>
                        </Col>

                        <Col md="4">
                            <FormGroup>
                                <Label htmlFor="validationCustom01">City</Label>
                                <Select
                                    name="city"
                                    value={cityValue}
                                    onChange={setCityValue}
                                    options={cityList}
                                    classNamePrefix="select2-selection"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="4">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Pin Code</Label>
                                <AvField
                                    name="pin"
                                    placeholder="Pin Code"
                                    type="text"
                                    errorMessage="Enter Pin Code"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    value={pin}
                                    onChange={(e) => setPin(e.target.value)}
                                    id="validationCustom02"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Route Vehicle Loaded</Label>
                                <AvField
                                    name="routeVehicleLoaded"
                                    placeholder="Route Vehicle Loaded"
                                    type="text"
                                    errorMessage="Enter Route Vehicle Loaded"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    value={routeVehicleLoaded}
                                    onChange={(e) => setRouteVehicleLoaded(e.target.value)}
                                    id="validationCustom02"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="profileLink">Profile Link</Label>
                                <AvField
                                    name="specialServices"
                                    placeholder="Paste YouTube video link"
                                    type="text"
                                    className="form-control"
                                    value={specialServices}
                                    onChange={(e) => setSpecialServices(e.target.value)}
                                    id="profileLink"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Vehicle Category</Label>
                                <Select
                                    value={transporterType}
                                    onChange={setTransporterType}
                                    options={transporterTypeOptions}
                                    classNamePrefix="select2-selection"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Verification</Label>
                                <Select
                                    options={[
                                        { label: "True", value: true },
                                        { label: "False", value: false }
                                    ]}
                                    value={verificationStatus}
                                    onChange={setVerificationStatus}
                                    classNamePrefix="select2-selection"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="validationCustom02">Survey</Label>
                                <Select
                                    options={[
                                        { label: "Yes", value: true },
                                        { label: "No", value: false }
                                    ]}
                                    value={surveyStatus}
                                    onChange={setSurveyStatus}
                                    classNamePrefix="select2-selection"
                                />
                            </FormGroup>
                        </Col>

                        <Col md="12">
                            {submitStatus && (
                                <div className="alert alert-danger fade show" role="alert">{alertMsg}</div>
                            )}
                        </Col>
                    </Row>
                    <Button color="success" type="submit">Submit</Button>
                </AvForm>
            </MtFormLayout>

            {conformMsg ? (
                <MtSweetAlert
                    alertTitle="Add Business Profile"
                    alertConfirmBtnText="Submit"
                    alertHandler={submitHandler}>
                    Do You Want To Submit Data
                </MtSweetAlert>
            ) : null}

            {successMsg ? (
                <MtSweetAlert
                    alertTitle="Business Profile"
                    alertConfirmBtnText="Go Back"
                    alertHandler={goBack}>
                    Business Profile Add Successfully
                </MtSweetAlert>
            ) : null}

            {errorStatus ? (
                <MtSweetAlert
                    alertTitle="Already Register"
                    alertConfirmBtnText="Go Back"
                    alertHandler={goBack}>
                    Business profile is already created
                    <Link
                        to={`/UpdateBusinessList?businessId=${businessId}`}
                        id="editProfile"
                        className="btn btn-info">
                        Current profile Update
                    </Link>
                </MtSweetAlert>
            ) : null}
        </React.Fragment>
    );
};

export default AddBusinessProfile;